import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faRocket } from '@fortawesome/pro-solid-svg-icons';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Add from "@material-ui/icons/Add";
import { CircularProgress } from '@material-ui/core';

import logo from "assets/img/cellfind_logo.png";
import Countries from 'assets/countries.json'

import Api from '../../api/Api.js';
import LicenseEndpoints from '../../api/LicenseEndpoints';
import Loading from '../../components/Loading/Loading';
import { store } from '../../redux/store';

import { replace } from 'connected-react-router';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Tasks from "components/Tasks/Tasks.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import Button from '../../components/CustomButtons/Button';
import ReactSelect from '../../components/Select/ReactSelect';
import Empty from '../../components/Empty/Empty';
import DataTable from '../../components/Table/DataTable';
import LicensePlugin from '../../plugins/License';
import { SET_PAGE_TITLE } from '../../redux/types';
import { ArrayDif } from '../../helpers';
import AccountImage from '../../components/Image/AccountImage';

const CertificateIcon = () => {
    return <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        <FontAwesomeIcon icon={faCertificate} size="10x" color="goldenrod" style={{ filter: 'drop-shadow(2px 2px 0 rgba(0,0,0,.5))' }} />
        {/* <FontAwesomeIcon icon={faRocket} size="5x" style={{ position: 'absolute', margin: 'auto', filter: 'drop-shadow(-1px -1px 0 #fff)' }} /> */}
        <img src={logo} height={80} width={80} style={{ position: 'absolute', margin: 'auto', filter: 'drop-shadow(-1px -1px 0 #000)' }} />
    </span>
}

const TestItems = [
    "MTN",
    "Vodacom",
    "Cell C",
    "Telkom"
]

class ViewLicense extends Component {

    constructor(props) {
        super(props);
        this.license_id = props.match.params.license_id;

        console.log(props)

        if (!this.license_id) {
            store.dispatch(replace('/license/search'));
        }

        store.dispatch({ type: SET_PAGE_TITLE, payload: 'Loading...' })
    }

    license_id;

    state = {
        license: null,
        tarrifs: [],
        selectedTarrif: { label: 'None', value: null },
        testsLoading: true,
        testsChecked: [],
        dialogOpen: false,
        stateChangeType: '',
        dialogLoading: false,
        newNote: '',
        allocateAccount: null,
        tarrifLoading: false
    }

    componentDidMount() {
        Api.get(LicenseEndpoints.details, { id: this.license_id })
            .then(({ data }) => this.setState({ license: data }, () => {
                store.dispatch({ type: SET_PAGE_TITLE, payload: this.state.license.product_reference })
                Api.get(LicenseEndpoints.testResults, { license_id: this.license_id })
                    .then(({ data }) => {
                        if (data.length === 0) {
                            this.setState({ testsLoading: false });
                            return;
                        }

                        var checked = [];
                        for (var i = 0; i < TestItems.length; i++) {
                            if (data.find(x => x.name === TestItems[i]).value == 'true') {
                                checked.push(i);
                            }
                        }
                        console.log(checked);
                        this.setState({ testsLoading: false, testsChecked: checked }, () => console.log("Tests:", this.state.testsChecked));
                    })
                Api.get(LicenseEndpoints.tarrifs).then(({ data }) => {
                    this.setState(
                        {
                            tarrifs: data.filter(x => (this.state.license.license_services === "USSD Strings" ? x.licensed_service_id === 1 : x.licensed_service_id === 2)).map(x => ({ ...x, label: x.name, value: x.id }))
                        },
                        () => {
                            if(this.state.license.license_tarrif_id) {
                                this.setState({ selectedTarrif: this.state.tarrifs.find(x => x.value === this.state.license.license_tarrif_id) });
                            }
                        }
                    );
                })
            }))
            .catch((e) => {
                store.dispatch(replace('/license/search'))
                console.error(e)
            })
    }

    renderStatus(status) {
        switch (status) {
            case 'allocated':
                return <h1 style={{ color: 'goldenrod', textShadow: '1px 1px 0 rgba(0,0,0,.5)', fontWeight: 'bold' }}>Allocated</h1>;
            case 'available':
                return <h1 style={{ color: 'var(--green)', textShadow: '1px 1px 0 rgba(0,0,0,.5)', fontWeight: 'bold' }}>Available</h1>;
            case 'in-house':
                return <h1 style={{ color: 'var(--blue)', textShadow: '1px 1px 0 rgba(0,0,0,.5)', fontWeight: 'bold' }}>In House</h1>;
            case 'reserved':
                return <h1 style={{ color: 'var(--purple)', textShadow: '1px 1px 0 rgba(0,0,0,.5)', fontWeight: 'bold' }}>Reserved</h1>;
        }
    }

    renderLicenseType(license) {
        var countryIndex = Countries.findIndex(x => x.code === license.country);
        return (<h3 style={{ marginTop: 0 }}>{license.tarrif ? license.tarrif + ' - ' : ''}{license.license_services} - {Countries[countryIndex].name}</h3>);
    }

    renderOwner(license) {
        if (license.status === 'allocated') {
            return <div>
                <h4 style={{ fontWeight: 'normal' }}>Allocated to:</h4>
                <h1><Link to={`/customer/view/${license.account.id}`} style={{ color: '#002366' }}><span style={{ fontSize: '1.5em' }}>{license.account.account_no} - {license.account.company}</span><br />{license.account.name}</Link></h1>
            </div>
        }
        return null;
    }

    renderNote(license) {
        if (license.notes)
            return <h5 style={{ color: '#444' }}>{license.notes}</h5>;
        else return null
    }

    renderOps(license) {
        if (license.ops_user)
            return (
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <h2 style={{ color: '#002366', marginBottom: '0', textDecoration: 'underline' }}>{license.ops_user.name} {license.ops_user.surname || ''}</h2>
                    <h4 style={{ color: '#002366', marginTop: '0' }}>Operations Agent</h4>
                </div>
            );
        return null;
    }

    renderSales(license) {
        if (license.sales_user)
            return (
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <h2 style={{ color: '#002366', marginBottom: '0', textDecoration: 'underline' }}>{license.sales_user.name} {license.sales_user.surname || ''}</h2>
                    <h4 style={{ color: '#002366', marginTop: '0' }}>Account Manager</h4>
                </div>
            );
        return null;
    }

    renderPopupTitle(status) {
        switch (status) {
            case 'allocated':
                return 'Allocate';
            case 'available':
                return 'Available';
            case 'in-house':
                return 'In House';
            case 'reserved':
                return 'Reserve';
        }
    }

    renderStateChangePopup() {
        return (
            <Dialog
                open={this.state.dialogOpen}
                onClose={() => this.setState({ dialogOpen: false })}
                fullWidth
                scroll="body"
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
                PaperProps={{ style: { overflow: 'visible' } }}
            >
                <DialogTitle id="form-dialog-title">{this.renderPopupTitle(this.state.stateChangeType)}</DialogTitle>
                <DialogContent style={{ overflow: 'visible' }}>
                    {
                        this.state.stateChangeType === 'allocated' ?
                            <ReactSelect
                                label="Select Account"
                                options={
                                    this.props.accounts.map(acc => ({ label: acc.account_no + " - " + acc.name, avatar: <AccountImage {...acc} />, value: acc.id }))
                                }
                                onChange={(value) => this.setState({ allocateAccount: value })}
                                placeholder="Select Account..."
                                value={this.state.allocateAccount}
                                isSearchable
                            />
                            : null
                    }

                    <CustomInput
                        labelText={<span>Note</span>}
                        id="new_note_message"
                        formControlProps={{
                            fullWidth: true,
                            variant: "outlined",
                            style: { zIndex: 0 }
                        }}
                        inputProps={{
                            autoFocus: true,
                            variant: "outlined",
                            multiline: true,
                            value: this.state.newNote,
                            onChange: (e) => this.setState({ newNote: e.target.value })
                        }}
                    />
                    {this.renderStatusChangePlugin(this.state.stateChangeType)}
                </DialogContent>
                <DialogActions>
                    {
                        this.state.dialogLoading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            [
                                <Button key="cancel" style={{ marginRight: 'auto' }} round onClick={() => this.setState({ dialogOpen: false })} color="rose" simple>
                                    Cancel
                                </Button>
                                ,
                                <Button
                                    key="submit"
                                    onClick={() => {
                                        this.setState({ dialogLoading: true },
                                            () =>
                                                Api.post(LicenseEndpoints.setStatus, {
                                                    status: this.state.stateChangeType,
                                                    id: this.license_id,
                                                    note: this.state.newNote,
                                                    account_id:
                                                        (
                                                            this.state.allocateAccount && this.state.allocateAccount.value ?
                                                                this.state.allocateAccount.value
                                                                :
                                                                null
                                                        )
                                                })
                                                    .then(({ data }) => this.setState({ license: data, dialogLoading: false, dialogOpen: false }))
                                                    .catch((e) => this.setState({ dialogLoading: false }, () => console.error(e))))
                                    }}
                                    color="rose"
                                    round
                                >
                                    Submit Change&nbsp;&nbsp;
                                    <Add />
                                </Button>
                            ]
                    }
                </DialogActions>
            </Dialog>
        );
    }

    renderStatusChangePlugin(status) {
        var PluginComponent = null;
        if (this.state.license.license_services === "Short Codes") {
            PluginComponent = LicensePlugin[2].onStateChange[status];
        }
        if (this.state.license.license_services === "USSD Strings") {
            PluginComponent = LicensePlugin[1].onStateChange[status];
        }
        if (PluginComponent)
            return (<PluginComponent license={this.state.license} />);
    }

    renderPlugin() {
        var PluginComponent = null;
        if (this.state.license.license_services === "Short Codes") {
            PluginComponent = LicensePlugin[2].view;
        }
        if (this.state.license.license_services === "USSD Strings") {
            PluginComponent = LicensePlugin[1].view;
        }
        if (PluginComponent)
            return (
                <GridItem xs={12} sm={12} md={6}>
                    <Card>
                        <CardBody>
                            {/* Plugin */}
                            <PluginComponent license={this.state.license} />
                        </CardBody>
                    </Card>
                </GridItem>
            );
    }

    render() {

        const { license } = this.state;

        if (!license) {
            return <Loading overlay />
        }

        return [
            <div key="certficate" style={{ border: '20px solid #002366', boxShadow: '0px 8px 30px 0px rgba(0,0,0,0.5)' }}>
                <div style={{ border: '6px solid #766', backgroundColor: '#fff8f8' }}>
                    <div style={{ minHeight: 400, position: 'relative', textAlign: 'center', paddingBottom: 50, paddingTop: 50 }}>
                        {this.renderStatus(license.status)}
                        <br />
                        <h1><span style={{ fontSize: '1.5em', fontWeight: 'normal' }}>{license.product_reference}</span></h1>
                        {this.renderLicenseType(license)}
                        <br />
                        {this.renderOwner(license)}
                        <br />
                        {this.renderNote(license)}
                        <br />
                        {/* Render Tests */}
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                            {this.renderOps(license)}
                            {this.renderSales(license)}
                        </div>
                        <div style={{ position: "absolute", bottom: 20, right: 20, opacity: license.status === 'allocated' ? 1 : 0.25 }}>
                            <CertificateIcon />
                        </div>
                    </div>
                </div>
            </div>,
            <GridContainer key="manage">
                <GridItem xs={12} sm={12} md={6}>
                    <Card>
                        <CardBody style={{ textAlign: 'center' }}>
                            <h3>Change Status</h3>
                            {/* Available, Allocate, In House, Reserved etc */}
                            {
                                license.status !== 'allocated' ?
                                    <Button style={{ backgroundColor: 'goldenrod' }} round onClick={() => this.setState({ stateChangeType: 'allocated', dialogOpen: true })}>
                                        Allocate
                                    </Button> : null
                            }
                            &nbsp;&nbsp;
                            {
                                license.status !== 'available' ?
                                    <Button color="success" round onClick={() => this.setState({ stateChangeType: 'available', dialogOpen: true })}>
                                        Make Available
                                    </Button> : null
                            }
                            &nbsp;&nbsp;
                            {
                                license.status !== 'in-house' ?
                                    <Button color="info" round onClick={() => this.setState({ stateChangeType: 'in-house', dialogOpen: true })}>
                                        In House
                                    </Button> : null
                            }
                            &nbsp;&nbsp;
                            {
                                license.status !== 'reserved' ?
                                    <Button color="primary" round onClick={() => this.setState({ stateChangeType: 'reserved', dialogOpen: true })}>
                                        Reserve
                                    </Button> : null
                            }
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <Card>
                        <CardBody>
                            {/* Tarrif */}
                            <ReactSelect
                                label="Tarrif"
                                options={this.state.tarrifs}
                                value={this.state.selectedTarrif}
                                onChange={(value) => this.setState({ selectedTarrif: value })}
                                isSearchable
                            />
                            <br />
                            {
                                this.state.tarrifLoading ?
                                    <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10, float: 'right' }} />
                                    :
                                    <Button
                                        color="success"
                                        style={{ float: 'right' }}
                                        round
                                        onClick={
                                            () =>
                                                this.setState({ tarrifLoading: true }, () =>
                                                    Api.post(LicenseEndpoints.setTarrif, { id: this.license_id, tarrif_id: this.state.selectedTarrif.value })
                                                        .then(({ data }) => this.setState({ license: data, tarrifLoading: false }))
                                                        .catch((e) => this.setState({ tarrifLoading: false }, () => console.error(e)))
                                                )
                                        }
                                    >
                                        Set Tarrif
                                    </Button>
                            }
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <Card loading={this.state.testsLoading}>
                        <CardBody style={{ textAlign: 'left' }}>
                            {/* Tests */}
                            <h3>Tests</h3>
                            <Tasks
                                checkedIndexes={this.state.testsChecked}
                                tasksIndexes={[0, 1, 2, 3]}
                                tasks={TestItems}
                                onCheckChange={(checkedList) => {
                                    var dif = ArrayDif(this.state.testsChecked, checkedList);
                                    for (var i = 0; i < dif.length; i++) {
                                        Api.post(LicenseEndpoints.testChange, { name: TestItems[dif[i]], value: (checkedList.length > this.state.testsChecked.length), license_id: this.license_id })
                                            .then(({ data }) => {
                                                console.log(data);
                                            })
                                            .catch((e) => {
                                                console.error(e);
                                            })
                                    }
                                    this.setState({ testsChecked: checkedList });
                                }}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <Card>
                        <CardBody>
                            {/* History */}
                            {
                                this.state.license.history.length === 0 ?
                                    <div style={{ textAlign: 'center' }}><Empty title="No History" subtitle="Must be a newborn license..." /></div>
                                    :
                                    <DataTable
                                        title={"License History"}
                                        data={
                                            this.state.license.history
                                                .map(hist => [hist.history_id, hist.status, (hist.account && hist.account.account_no) || 'n/a', hist.notes, hist.start, hist.end])
                                        }
                                        columns={historyColumns}
                                    />
                            }
                        </CardBody>
                    </Card>
                </GridItem>
                {this.renderStateChangePopup()}
                {this.renderPlugin()}
            </GridContainer>
        ];
    }
}

const historyColumns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Status",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Account",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Notes",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Start",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "End",
        options: {
            filter: true,
            sort: true,
        }
    }
];

const mapStateToProps = ({ customers }) => ({ accounts: customers.list })

export default connect(mapStateToProps)(ViewLicense);